import { MiddlewareAPI } from '@reduxjs/toolkit';
import { updateState } from 'core/actions/product/state';
import { authRequest } from 'core/services/authentication';
import { logout } from 'core/slices/session';
import { ConnectionState, updateConnectionState, recieve, send } from 'core/slices/websocket';
import { MessageModel } from 'types/websocket';
import { TypeSocket } from './typesocket';

export const socketMiddleware: any = () => {
  return (store: MiddlewareAPI<any, any>) => {
    const socket: TypeSocket<any> = new TypeSocket<MessageModel>(null, {maxRetries: 1});

    let interval = null;


    socket.on('connected', () => {
      store.dispatch(updateConnectionState(ConnectionState.CONNECTED));
      interval = setInterval(() => socket.send('ping'), 60000);
    });
    socket.on('disconnected', () => {
      store.dispatch(updateConnectionState(ConnectionState.DISCONNECTED));
      clearInterval(interval);
    });
    socket.on('message', message => store.dispatch(recieve(message)));

    return (next: (action: any) => void) => (action: any) => {
      const token = getToken(action);
      //@ts-ignore
      if (token && token !== undefined && socket.readyState === 0 && !socket.url) {
        try {
          //console.log(action);
          socket.connect(`${process.env.REACT_APP_WS}/socket?token=${token}`);
        } catch (e) {
          store.dispatch(logout);
        }
      }

      if (action.type && socket.readyState === 1) {
        switch (action.type) {
          case send.type:
            socket.send(action);
            break;
          case updateState.type:
            socket.send(action);
            break;
        }
      }

      return next(action);
    };
  };
};

function getToken(action) {
  if (!action) return null;

  switch (action.type) {
    case authRequest.fulfilled.type:
      return action.payload?.token;
    case 'hydrate':
      return action.payload.session ? action.payload.session.jwt : null;
  }
}
